import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse'


class SingleSelectResponse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: 0,
            isSelect: false,
	      responseValue: 0,
            acceptComment: null,
	      tempVal: '',
	      checked:false
        };

        this.isUpdateResponse = false;
        this.reviewPage = this.props.questionItemList || [];
    this.ratees = this.props.assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];
    }

    componentWillReceiveProps(nextProps) {

        if (this.isUpdateResponse !== true) {
      const { getAllItemResponse, items, configuration, getAllItemResponseForMultiple, ratees, rateeKey, putAllForItemCollection, getResPonsesOnLoad, pageList, activePageKey } = nextProps;

      if(ratees.length > 1) {
      var nodeList = document.getElementsByName(`singleResponse_${items.key}_${rateeKey}`);
      } else {
         var nodeList = document.getElementsByName(`singleResponse_${items.key}`);
      }

      var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);
	  items.isHide = false;

            for (const key in getAllItemResponseForMultiple) {

                if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
                    const elementRes = getAllItemResponseForMultiple[key];

                    if (rateeKey !== undefined && key === rateeKey) {
                        const { itemResponseSets } = elementRes;

                        for (const key in itemResponseSets) {
                            if (itemResponseSets.hasOwnProperty(key)) {
                                this.isUpdateResponse = true;

                                const element = itemResponseSets[key];
                                const tempItemResponseSets = itemResponseSets[key];

                                if (element.itemKey.toLowerCase() === items.key.toLowerCase()) {
                                    var responseValue = element.itemResponses.length > 0 ? element.itemResponses[0].response : element.demographicResponses.length > 0 ? element.demographicResponses[0].response : null;

                                    if (this.state.isSelect === false) {
                                        this.setState({
                                            isSelect: true,
                                            responseValue: responseValue,
                                        });
                                    }
                  
                  		if (tempItemResponseSets.itemResponses.length > 0) {
                                    for (const key in tempItemResponseSets.itemResponses) {
                                        if (tempItemResponseSets.itemResponses.hasOwnProperty(key)) {

                                            const temp = tempItemResponseSets.itemResponses[key];
                                            const itemList = this.reviewPage[items.reviewPageKey];

                                            for (const key in itemList) {
                                                if (itemList.hasOwnProperty(key)) {
                                                    const itemRes = itemList[key];
                                                    var itemResponseArr = tempItemResponseSets.itemResponses.length > 0 ? tempItemResponseSets.itemResponses : tempItemResponseSets.demographicResponses.length > 0 ? tempItemResponseSets.demographicResponses : [];

                                                    if (this.state.isSelect === false) {
                                                        for (const key in nodeList) {
                                                            if (nodeList.hasOwnProperty(key)) {
                                                                const element = nodeList[key];

                                    if (element.value == responseValue) {
                                                                    element.checked = true;
										this.handleRadioButtonCheck(`input[type=radio][name=singleResponse_${ratees.length > 1 ? rateeKey:items.key}]`);
                                                                    this.setState({ acceptComment: itemResponseArr[0].openEnd });

                                        if (this.ratees.length < 2) {
										this.handleSkipPage(responseValue);
                                            this.handleDependencyPageSkipLogic();
											if (element.checked) {
												this.handleDependencyRequired(element.checked, items.key, element.value);
											}
                                        }

                                                                    if (configuration.acceptComment !== null && itemResponseArr[0].openEnd !== null) {
                                                                        inputBoxList[key].classList.add('_acceptCommentShow');
                                                                    }
                                                                }

                                                        }
												}
												
                                                    // itemRes.isAnswer = (itemRes.responseValue !== null) || (itemRes.response !== null) ? true : false;
                                                    itemRes.isAnswer = (temp.responseValue !== null) || (temp.response !== null) ? true : false;
												itemRes.isRequired = (temp.responseValue !== null) || (temp.response !== null) ? false : itemRes.requiredIndicator == 2 ? true: false;

                                                        itemRes.itemResponses[tempItemResponseSets.itemKey] = itemResponseArr;
                                                        var itemType = configuration.itemType;
                                                        var responseSet = this.props.itemResponses[tempItemResponseSets.itemKey] = {};
												processItemResponse(tempItemResponseSets.itemKey, responseSet, tempItemResponseSets.itemResponses, itemType, rateeKey, putAllForItemCollection,"onLoad");
												if(ratees.length > 1) {
													getResPonsesOnLoad(items.key, tempItemResponseSets, rateeKey);
												}

                                                    }
                                                }
                                            }
                                        }
                                    }
                } else {
                  if (items.requiredIndicator == 2) {
                      items.isRequired = true;
                  } else {
                      items.isRequired = false;
                  }
              }
                }
                            }
                        }
                    }
                }
            }
        }
    }

    componentDidMount() {
        const { responseValue } = this.state;
	  if (this.ratees.length < 2) {
            this.handleDependencyPageSkipLogic();
          this.handleSkipPage(responseValue);
      }


	  	
	  if(this.ratees.length > 1){
        if (this.isUpdateResponse !== true) {
            const { items, activePageKey} = this.props;
				if (items.requiredIndicator == 2) {
					const nextButton = document.getElementsByClassName(`_buttonHideClass_${activePageKey}`)[0];
					nextButton.disabled = true;
					nextButton.classList.add("_PageNextButtonDisable");
				} 
			}
      }
	//   this.handleRadioButtonCheck(`input[type=radio][name=singleResponse_${this.props.items.key}]`);
    }

  handleChange = (event, configuration, rateeKey, index, type, value) => {
        try {
      const { items, handleItemResponse, singleSelectItemConfiguration, itemTempResponses, flag, ratees, putAllForItemCollection } = this.props;
		const { responseDescription, response, responseValue, reversePolarityResponseValue } = configuration;
      var acceptComment = type === "input" ? event.target.value : null;

            this.setState({
                isSelect: true,
                active: responseValue,
        responseValue: items.isReversePolarity ? reversePolarityResponseValue : responseValue,
        acceptComment: acceptComment,
            });

	  let setResponseValue = items.isReversePolarity === true ? reversePolarityResponseValue : responseValue;
      this.handleRadioButtonCheck(`input[type=radio][name=singleResponse_${items.key}]`);
      var nodeList = document.getElementsByName(`singleResponse_${items.key}`);
      var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);
      var checkboxAnswer = false;

      if ((acceptComment === null || acceptComment === "") && parseInt(configuration.acceptComment) === 2  && flag !== "MultiUser") {
                inputBoxList[index].classList.add('_acceptCommentRequired');
                this.handleCheckboxElement(true);
            } else {
                inputBoxList[index].classList.remove('_acceptCommentRequired');
                this.handleCheckboxElement(false);
            }

        if (flag !== "MultiUser") {
            for (const key in nodeList) {
                if (nodeList.hasOwnProperty(key)) {
                    const element = nodeList[key];
                //inputBoxList[key].value = null;

                    if (element.checked && configuration.acceptComment !== null) {
                        inputBoxList[key].classList.remove('_acceptCommentHide');
                        inputBoxList[key].classList.add('_acceptCommentShow');

                    } else {
                        inputBoxList[key].classList.remove('_acceptCommentShow');
                        inputBoxList[key].classList.add('_acceptCommentHide');
                    }
                }
            }
        }

            /* Manage the question answer response */
            for (const key in this.reviewPage[items.reviewPageKey]) {

                if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
                    const itemList = this.reviewPage[items.reviewPageKey];
                    var itemKey = itemList[key].key;

                    if (itemList[key].key === items.key) {
				itemList[key].isAnswer = value !== "unChecked" ?  true : false;

            if (itemList[key].requiredIndicator == 2) {
					itemList[key].isRequired = value !== "unChecked" ?  false : true;
				} else {
					itemList[key].isRequired = false;
          }

                        for (const rKey in ratees) {

                            if (ratees.hasOwnProperty(rKey)) {
                                const tempRatees = ratees[rKey];

                                if (tempRatees.dataCollectionGuid === rateeKey) {

                                    itemList[key].itemResponses[itemKey] = [{
                                        "itemType": singleSelectItemConfiguration.itemType,
                                        "buttonGroup": null,
                                        "sequence": 1,
                                        "isNa": itemList[key].isNA,
						"response": value && value !== "unChecked" ? response : acceptComment !== null ? response : flag !== "MultiUser" ? null : response,
						"responseValue": value && value !== "unChecked" ? setResponseValue : acceptComment !== null ? setResponseValue : flag !== "MultiUser" ? null : setResponseValue,
                                        "openEnd": acceptComment,
                                        "responseDescription": responseDescription
                                    }];

                                    var responseSet = this.props.itemTempResponses[itemKey] = {};
                                    var itemResponses = itemList[key].itemResponses[itemKey];
                                    var itemType = singleSelectItemConfiguration.itemType;

                                    if (itemType !== "101") {
                    itemResponses = itemList[key].itemResponses[itemKey];
                                    } else {
                    var tempList = itemList[key].itemResponses[itemKey];
                                        delete tempList.buttonGroup;
                                        delete tempList.responseValue;
                                        itemResponses = [tempList];
                                    }
                    if (this.ratees.length < 2) {
					this.handleSkipPage(value !== "unChecked" ? response : 0);
                    }
					processItemResponse(itemKey, responseSet, itemResponses, itemType, rateeKey, putAllForItemCollection,"onChange");
                                }
                            }
                        }
					checkboxAnswer = itemList[key].isAnswer;
                    } else {
                        if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
                    }
                    this.setState({ itemResponses: itemList[key].itemResponses[itemList[key].key] });
                }
            }

            /* Select box active whenever select */
            if (type === "selectBox") {
                var option = `select_box_${configuration.responseValue}_${items.key}`;
                var singleBoxActive = document.getElementsByName(`singleBox_${items.key}`);

                for (var i = 0; i < singleBoxActive.length; i++) {
                    singleBoxActive[i].classList.remove("active");
                }

                document.getElementById(option).classList.add("active");
            }
		  if (this.ratees.length < 2) {
      this.handleDependencyRequired(checkboxAnswer, items.key, response);
            this.handleDependencyPageSkipLogic();
            }
            handleItemResponse(items.key, itemTempResponses, "itemChange", rateeKey);
        } catch (error) {
            console.log("Exception: while responding question answer in single select response:_", error);
        }
    }

  handleDependencyPageSkipLogic = () => {
    var timeOut = setTimeout(() => {
        const { items, nextPageKey, dependencies, pageList } = this.props;

        for (const key in dependencies) {
            if (Object.hasOwnProperty.call(dependencies, key)) {
                const element = dependencies[key]

                element.filter((dep) => {
                    if (dep.dependsOnKey === items.key) {
                        pageList.filter((page) => {
                           // if (page.key == nextPageKey) {
                                const { items } = page;
                                page.checkOnNextButtonClick = false;

                                items.filter((itm) => {
                                    if (itm.hasDepend == true) {
                                        page.checkOnNextButtonClick = true;
                                    }
                                });
                           // }
                        })
                    }
                })
            }
        }
        clearTimeout(timeOut)
    }, 0);
}

    handleSkipPage = (tempResponseValue) => {
        try {
		const { dependencies, items } = this.props;
		var responseValue = tempResponseValue;
      	    var nodeList = document.getElementsByName(`singleResponse_${items.key}`);

            for (const key in dependencies) {
                if (Object.hasOwnProperty.call(dependencies, key)) {
                    const element = dependencies[key];

                    element.filter((dep) => {
                        if (dep.dependsOnKey === items.key) {

                            var skipDiv = document.getElementById("survey-item-block_" + dep.key);
              var skipDivOld = document.getElementsByName("survey-item-block");

              var conditionString = "";
              element.map((item, i) => {
                  return conditionString += `( ${item.response} ${item.booleanOperator} ${tempResponseValue} ) ${item.dependsOnConditionalOperator !== null ? item.dependsOnConditionalOperator : ""}`
              });

              var newStr = conditionString.length > 15 ? conditionString.substr(0, conditionString.length - 1) : conditionString;
              var result = newStr.split(') |').join(")");
              var newCondition = result.split('|').join("||");

              if (newCondition !== '' && eval(newCondition)) {
							for (const key in skipDivOld) {
								if (Object.hasOwnProperty.call(skipDivOld, key)) {
                          const dataId = skipDivOld[key].getAttribute('data-id');

                          if (dataId == dep.key) {
                              skipDivOld[key].classList.remove('_Unblock');
                              skipDivOld[key].classList.add('_block');
										skipDivOld[key].classList.add(`_block_${items.key}_${responseValue}`);
                          }
                      }
                            }
                            } else {
                  for (const key in nodeList) {
                      if (Object.hasOwnProperty.call(nodeList, key)) {
                          const element = nodeList[key];

                                    var newEl = document.getElementsByClassName(`_block_${items.key}_${element.value}`)[0];
                          if (!element.checked) {
											var dataId = skipDivOld[key].getAttribute('data-id');

											if (newEl !== undefined) {
												newEl.classList.remove('_block');
												newEl.classList.remove(`_block_${items.key}_${element.value}`);
												newEl.classList.add('_Unblock');
                              }
                          }
                      }
                  }
                            if (this.state.isSelect) {
							} else {
								skipDiv.style.display = "none";
							}
							//  return false;
                            }
                        }
                    })
                }
            }
        } catch (error) {
            // console.log("Exceptions: while skipping item and page", error.message);
        }
    }


handleDependencyRequired = (checkboxAnswer, itemKey, response) => {
    try {
        var test = setTimeout(() => {
        const { pageList, nextPageKey,activePageKey } = this.props;

            var _blockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._block`);
            var _unBlockElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._Unblock`);

			var _blockActivePageElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._block`);
            var _unBlockActiveElement = document.querySelectorAll(`._SurveyPageLevel_${nextPageKey} ._Unblock`);

            for (const key in pageList) {
                if (Object.hasOwnProperty.call(pageList, key)) {
                    if (pageList[key].key == nextPageKey) {
                        const tempItems = pageList[key].items;
						
						for (const key in tempItems) {
							if (Object.hasOwnProperty.call(tempItems, key)) {
								const element = tempItems[key];
								for (const depKey in _blockElement) {
									if (Object.hasOwnProperty.call(_blockElement, depKey)) {
										const dataId = _blockElement[depKey].getAttribute('data-id');

										if (element.key === dataId) {
										element.isHide = false;
										} else {
										element.isHide = true;
										}

									}
								}

								for (const bKey in _unBlockElement) {
										if (Object.hasOwnProperty.call(_unBlockElement, bKey)) {
											const dataIdUnblock = _unBlockElement[bKey].getAttribute('data-id');

											if (element.key === dataIdUnblock) {
											element.isHide = true;
											}
										}
									}
								}
							}
					} else {
						if (pageList[key].key == this.props.activePageKey) {
								const tempItems = pageList[key].items;
								for (const key in tempItems) {
									if (Object.hasOwnProperty.call(tempItems, key)) {
										const element = tempItems[key];
										if(this.props.dependencies != undefined) {
											for( const depKey in this.props.dependencies) {
												this.props.dependencies[depKey].map((dep) => {
													if(itemKey == dep.dependsOnKey && response == dep.response && element.hasDepend == false ){
														this.props.handleDynamicDependency(checkboxAnswer, dep.key, response,"samePage",element.requiredIndicator);
														for (const depKey in _blockActivePageElement) {
															if (Object.hasOwnProperty.call(_blockActivePageElement, depKey)) {
																const dataId = _blockActivePageElement[depKey].getAttribute('data-id');
						
																if (element.key === dataId) {
																element.isHide = false;
																} else {
																element.isHide = true;
																}
						
															}
														}
														for (const bKey in _unBlockActiveElement) {
															if (Object.hasOwnProperty.call(_unBlockActiveElement, bKey)) {
																const dataIdUnblock = _unBlockActiveElement[bKey].getAttribute('data-id');
					
																if (element.key === dataIdUnblock) {
																	element.isHide = true;
																}
															}
														}
													}
													if(element.hasDepend == true && element.layoutHints == 'samepage') {
														if(itemKey == dep.key){
															this.props.handleDependentItem(itemKey,dep.response,null);
														}
													}
												});
											}
										}
									}
								
								}
						}
					}
                }
            }

            clearTimeout(test);
        }, 0);

    } catch (error) {

    }
}

    handleCheckboxElement = (flag) => {
        try {
            const { items } = this.props;
            var nodeList = document.getElementsByName(`singleResponse_${items.key}`);

            for (const key in nodeList) {
                if (Object.hasOwnProperty.call(nodeList, key)) {
                    const element = nodeList[key];
                    // element.disabled = flag;
                }
            }
        } catch (error) {
            console.log("Exceptions: Handled the enabled and disabled radio in required case:_", error.message)
        }
    }

    handleRequired = (event, index) => {
        const { items, configuration } = this.props;
        var inputBoxList = document.getElementsByName(`acceptComment_${items.key}`);

        if ((this.state.acceptComment === null || this.state.acceptComment === "") && parseInt(configuration.acceptComment) === 2) {
            inputBoxList[index].classList.add('_acceptCommentRequired');
            inputBoxList[index].focus();
            this.handleCheckboxElement(true);

        } else {
            inputBoxList[index].classList.remove('_acceptCommentRequired');
            this.handleCheckboxElement(false);
        }
    }

handleRadioButtonCheck = (groupSelector) => {
		const { configuration, rateeKey, indexKey } = this.props;
	let currentId;
		
		let _this = this;
	document.querySelectorAll(groupSelector).forEach((elem) => {
		elem.addEventListener('click', allowUncheck);
		if (elem.checked) {
			currentId = elem.id;
      }
	});

	function allowUncheck(e) {
		if (this.id === currentId) {
		this.checked = false;
			currentId = undefined;

				if (configuration.response == this.value) {
					_this.handleChange(this, configuration, rateeKey, indexKey, null, "unChecked");
				}
		} else {
			currentId = this.id;
    }
  }
}


    render() {
    const {
      configuration,
      suppressLabel,
      id,
      rateeKey,
      items,
      itemKey,
      className,
      indexKey,
      horizontalAlignment,
      flag,
    } = this.props;
        const customClass = items.layoutHints === "vertical" ? className : "single-select-response-radio-horizontal";
        const column = items.layoutHints === "vertical" ? 8 : 2;
        const radioLabel = items.layoutHints === null ? "radio-label" : "radio-horizontal-label";
        const alignmentFlag = horizontalAlignment !== null ? horizontalAlignment : items.horizontalAlignment !== null ? items.horizontalAlignment:"";

        return (
            <Fragment>
        {items.layoutHints === "radio" ||
          items.layoutHints === "radioHorizontal" ? (
          <Col
            xs={column}
            key={itemKey}
            className={`_LIS_SingleSelect ${customClass}`}
          >
                            <Col col={10}>
                                <input
                                    key={items.key}
                type="radio"
                                    name={`singleResponse_${items.key}`}
                                    id={`singleResponse_${configuration.response}_${items.key}`}
                                    className="_SingleSelectLabel"
                                    value={configuration.response}
                                    title={configuration.responseTooltip}
                onChange={(event) =>
                  this.handleChange(
                    event,
                    configuration,
                    rateeKey,
                    indexKey,
                    "radio"
                  )
                }
                                />

              {suppressLabel ? null : (
                <label
                  for={`singleResponse_${configuration.response}_${items.key}`}
                  className="_label"
                >
                                        <span
                                            title={configuration.responseTooltip}
                                            className={"radio-label"}
                                            htmlFor={id}
                    dangerouslySetInnerHTML={{
                      __html: configuration.responseDescription,
                    }}
                  ></span>
                </label>
              )}
                                <span className="_CommentBoxSpan">
                                    <input
                                        className="_acceptCommentHide"
                                        name={`acceptComment_${items.key}`}
                                        value={this.state.acceptComment}
                  onChange={(event) =>
                    this.handleChange(
                      event,
                      configuration,
                      rateeKey,
                      indexKey,
                      "input"
                    )
                  }
                                        onBlur={(event) => this.handleRequired(event, indexKey)}
                                    />
                                </span>
                            </Col>
                        </Col>
        ) : items.layoutHints === "singleBox" ? (
                            <div key={itemKey} className={"single-select-box-list"}>
                                <button
                                    key={configuration.key}
                                    id={`select_box_${configuration.responseValue}_${items.key}`}
                                    type="button"
                                    name={`singleBox_${items.key}`}
                                    class={`list-group-item list-group-item-action`}
              onClick={(event) =>
                this.handleChange(
                  event,
                  configuration,
                  rateeKey,
                  indexKey,
                  "selectBox"
                )
              }
                                >
              <span
                dangerouslySetInnerHTML={{
                  __html: configuration.responseDescription,
                }}
              ></span>
                                </button>
                            </div>
        ) : flag !== undefined && flag == "MultiUser" ? (
          <><input
            key={items.key}
            type="radio"
            name={`singleResponse_${items.key}_${rateeKey}`}
            id={`singleResponse_${configuration.response}_${items.key}`}
            className="_SingleSelectLabel _multiRadio"
            value={configuration.response}
            title={configuration.responseTooltip}
            onChange={(event) =>
              this.handleChange(
                event,
                configuration,
                rateeKey,
                indexKey,
                "radio"
              )
            }
          /><span className="_CommentBoxSpan">
          <input
            className="_acceptCommentHide"
            name={`acceptComment_${items.key}`}
            value={this.state.acceptComment}
            onChange={(event) =>
              this.handleChange(
                event,
                configuration,
                rateeKey,
                indexKey,
                "input"
              )
            }
            onBlur={(event) => this.handleRequired(event, indexKey)}
          />
        </span></>
        ) : (
          <div>
                                <Row>
              <Col xs={12} key={itemKey} className={`_LIS_SingleSelect`}>
                {configuration.scalePreSection !== null ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: processResponse(
                        configuration.scalePreSection
                      ),
                    }}
                  ></div>
                ) : null}
                                        <Col col={10}>
                  {alignmentFlag === "right" ? (
                    <label
                      for={`singleResponse_${configuration.response}_${items.key}`}
                      className={"_label label-right"}
                    >
                                                    <span
                                                        title={configuration.responseTooltip}
                                                        className={"radio-label"}
                                                        htmlFor={id}
                        dangerouslySetInnerHTML={{
                          __html: configuration.responseDescription,
                        }}
                      ></span>
                                                    <span className="_CommentBoxSpan">
                                                        <input
                                                            className="_acceptCommentHide _SingleSelectCommentBox"
                                                            name={`acceptComment_${items.key}`}
                                                            value={this.state.acceptComment}
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              configuration,
                              rateeKey,
                              indexKey,
                              "input"
                            )
                          }
                          onBlur={(event) =>
                            this.handleRequired(event, indexKey)
                          }

                                                        />
                                                    </span>
                    </label>
                  ) : null}

                                                <input
                                                    key={items.key}
                    type="radio"
                                                    name={`singleResponse_${items.key}`}
                                                    id={`singleResponse_${configuration.response}_${items.key}`}
                                                    className="_SingleSelectLabel"
                                                    value={configuration.response}
                                                    title={configuration.responseTooltip}
                    onChange={(event) =>
                      this.handleChange(
                        event,
                        configuration,
                        rateeKey,
                        indexKey,
						  "radio",
						"checked"
                      )
                    }

                  />

                  <label
                    for={`singleResponse_${configuration.response}_${items.key}`}
                    className={`${alignmentFlag === "left" ? "_label" : ""
                      } label-right`}
                  >
                    {alignmentFlag === "left" ? (
                                                    <span
                                                        title={configuration.responseTooltip}
                                                        className={"radio-label"}
                                                        htmlFor={id}
                        dangerouslySetInnerHTML={{
                          __html: configuration.responseDescription,
                        }}
                      ></span>
                    ) : null}

                                                    <span className="_CommentBoxSpan">
                                                        <input
                                                            className="_acceptCommentHide _SingleSelectCommentBox"
                                                            name={`acceptComment_${items.key}`}
                                                            value={this.state.acceptComment}
                        onChange={(event) =>
                          this.handleChange(
                            event,
                            configuration,
                            rateeKey,
                            indexKey,
                            "input"
                          )
                        }
                        onBlur={(event) =>
                          this.handleRequired(event, indexKey)
                        }
                                                        />
                                                    </span>
                                            </label>
                  {alignmentFlag === "center" ? (
                    <label
                      for={`singleResponse_${configuration.response}_${items.key}`}
                      className={"_label_center label-right"}
                    >
                                                    <span
                                                        title={configuration.responseTooltip}
                                                        className={"radio-label-center"}
                                                        htmlFor={id}
                        dangerouslySetInnerHTML={{
                          __html: configuration.responseDescription,
                        }}
                      ></span>
                                                    <span className="_CommentBoxSpan">
                                                        <input
                                                            className="_acceptCommentHide _SingleSelectCommentBox"
                                                            name={`acceptComment_${items.key}`}
                                                            value={this.state.acceptComment}
                          onChange={(event) =>
                            this.handleChange(
                              event,
                              configuration,
                              rateeKey,
                              indexKey,
                              "input"
                            )
                          }
                          onBlur={(event) =>
                            this.handleRequired(event, indexKey)
                          }
                                                        />
                                                    </span>
                    </label>
                  ) : null}
                                        </Col>
                {configuration.scalePreSection !== null ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: processResponse(
                        configuration.scalePreSection
                      ),
                    }}
                  ></div>
                ) : null}
                                    </Col>
                                </Row>
                            </div>
        )}
            </Fragment>
    );
    }
}

const mapStateToProps = (state) => ({
    answeredQuestionCount: state.survey.answeredQuestionCount,
    getAllItemResponse: state.survey.getAllItemResponse,
  getAllItemResponseForMultiple: state.survey.getAllItemResponseForMultiple,
  assessmentInfosForDataCollection: state.survey.assessmentInfoDataCollectionData,
})

export default connect(mapStateToProps)(SingleSelectResponse);
